import type { BCMediaInfo, LatestVideoResponse } from "@typings/Brightcove.d";
import { format, parseISO } from "date-fns";

export default function getProcessedBCResponse(
  data: BCMediaInfo[],
): LatestVideoResponse[] {
  return data.map((item) => {
    const {
      id,
      description,
      long_description,
      name,
      published_at,
      duration,
      thumbnail,
      poster,
      tags,
    } = item;

    const totalSeconds = duration / 1000;
    const minutes = Math.floor(totalSeconds / 60);
    const remainingSeconds = Math.floor(totalSeconds % 60);
    const formattedTime = `${minutes}:${remainingSeconds < 10 ? "0" : ""}${remainingSeconds}`;
    const date = new Date(published_at);
    const parsedDate = parseISO(published_at);
    return {
      id,
      description,
      long_description,
      name,
      published_at: format(date, "dd MMM yyyy - hh:mm aaa"),
      topStoryDate: format(parsedDate, "dd MMM yyyy - hh:mm aaa"),
      published_date: published_at,
      duration: duration,
      formattedTime: formattedTime,
      nowPlaying: false,
      thumbnail,
      poster,
      tags,
    };
  });
}
